const BaseComponent = require('base/base-component');
const Util = require('helper/util');

class journalList extends BaseComponent {
  constructor () {
    super({
      events: {
        'mouseenter .journal-num li': 'hoverEvent',
        'click .Jjournal': 'handleJournal'
      }
    });
  }
  hoverEvent (e) {
    $(e.currentTarget).addClass('active').siblings()
      .removeClass('active');
    $($('.cover-pic img').get($(e.currentTarget).index())).removeClass('hide').siblings()
      .addClass('hide');
  }
  handleJournal (e) {
    const browser = Util.BrowserType();
    const source = $(e.target).data('source');
    if (['IE9', 'IE8', 'IE7', 'IE6', '0'].indexOf(browser) > -1) {
      window.location.href = source;
    } else {
      window.location.href = `/pdf/web/viewer.html?file=${source}`;
    }
  }
}
module.exports = journalList;
